'use strict';
angular.module('mean.accounts-receivable').factory('TradeDrawService', ['$q', '$filter', 'BillingSettings', 'Trades',
    function($q, $filter, BillingSettings, Trades) {

        var data = {};
        var current_trade_code = null;
        var current_company_code = null;
        var draw_data = [];

        //list of draws for the view
        function loadSettings(trade_code, company_code, trade) {
            BillingSettings.query({
                'trade_code': trade_code, 
                'company_code': company_code }, function(billing_settings) {
                if(billing_settings.length === 0) {
                    Trades.query({
                        basic_contact: true, 
                        trade: trade,
                        company_code: company_code }, function(trades) {

                        var set = new BillingSettings({
                            trade_code: trade_code,
                            company_code: company_code,
                            company_info: {
                                name: trades[0].name,
                                address_one: trades[0].address_one,
                                address_two: trades[0].address_two,
                                city: trades[0].city,
                                state: trades[0].state,
                                zip: trades[0].zip,
                                phone: trades[0].phone,
                                email: trades[0].email,
                            }
                        });

                        set.$save(function(success) {
                            data = success
                        }, function(error) {
                            toaster.pop('error', 'Save Settings Error', error);
                        });
                    });
                } else {
                    data = billing_settings[0];
                }
            });
        }

        function getSettings() {
            return data;
        }

        // selection = vm.state.selection
        function getBuilder(trade_code, company_code, selection) {
            var deferred = $q.defer();

            if(!data.builders) {
                deferred.resolve(null);
                return;
            }

            var builder = $filter('filter')(data.builders, {
                'trade_code': trade_code, 'company_code': company_code }, true)[0];

            if(!builder) {
                var builder = {};
                builder.name = selection.builder_name;
                builder.address_one = selection.builder_address_one;
                builder.address_two = selection.builder_address_two;
                builder.company_code = company_code;
                builder.trade_code = trade_code;
                builder.auto_bill = false;

                data.builders.push(builder);
                data.$update(function(success) {
                    data = success;
                    var builder = $filter('filter')(data.builders, {
                        'trade_code': trade_code, 'company_code': company_code }, true)[0];
                    deferred.resolve(builder);
                }, function(error) {
                    toaster.pop('error', 'Settings Update Error', error)
                });
            } else {
                deferred.resolve(builder);
            }

            return deferred.promise;
        }

        function getProjectDraws(builder_name, trade_code, company_code, job_code) {
            draw_data = [];
            current_trade_code = trade_code;
            current_company_code = company_code;
            var builder = $filter('filter')(data.builders, {
                'name': builder_name, 'trade_code':trade_code, 'company_code': company_code }, true);

            if(builder.length === 1) {
                var projects = $filter('filter')(builder[0].projects, {'job_code':job_code }, true);

                if(projects.length === 1) {
                    _.each(projects[0].draws, function(draw) {
                        var row_data = {
                            'show_number': true,
                            'number': draw.number,
                            'name': draw.name,
                            'revision': (draw.revision)?draw.revision:0,
                            'task_code': draw.task_code,
                            'v_or_p': draw.v_or_p,
                            'value': draw.value
                        }
                        var task_code = draw.task_code;
                        var percentage = (draw.v_or_p=='P')?true:false;
                        if(percentage && row_data)
                            var p_value = row_data.value;

                        _.each(draw.plans, function(plan) {
                            draw_data.push({
                                show_number: false,
                                number: draw.number,
                                name: null,
                                task_code: task_code,
                                revision: null,
                                v_or_p: null,
                                value: null,
                                plan: plan.plan,
                                contract: plan.contract,
                                draw: (percentage)?plan.contract*p_value:plan.draw,
                                show_input: percentage
                            });

                            if(row_data) {
                                draw_data[draw_data.length-1].show_number = row_data.show_number;
                                draw_data[draw_data.length-1].number = row_data.number;
                                draw_data[draw_data.length-1].name = row_data.name;
                                draw_data[draw_data.length-1].task_code = row_data.task_code;
                                draw_data[draw_data.length-1].revision = row_data.revision;
                                draw_data[draw_data.length-1].v_or_p = row_data.v_or_p;
                                draw_data[draw_data.length-1].value = row_data.value;
                                draw_data[draw_data.length-1].show_input = percentage;
                                row_data = null;
                            }
                        });
                    });
                }
            }

            return draw_data;
        }

        function getProjectSettings(trade_code, company_code, job_code) {
            var builder = $filter('filter')(data.builders, {
                'trade_code':trade_code, 'company_code': company_code }, true);

            if(builder.length === 1) {
                var projects = $filter('filter')(builder[0].projects, {
                    'job_code':job_code }, true);

                if(projects.length === 1) {
                    return projects[0];
                }
            }

            return null;
        }

        function getProjectOptions(trade_code, company_code, job_code) {
            var builder = $filter('filter')(data.builders, {
                'trade_code':trade_code, 'company_code': company_code }, true);

            if(builder.length === 1) {
                var projects = $filter('filter')(builder[0].projects, {
                    'job_code':job_code }, true);

                if(projects.length === 1) {
                    return projects[0].options;
                }
            }

            return null;
        }

        //need to set up a call to get the contract totals by plan
        function add(selection, length, plans, trade, revision) {
            var row_data = {
                'show_number': true,
                'number': length+1,
                'name': selection.name,
                'revision': revision,
                'task_code': selection.task_code,
                'v_or_p': selection.v_or_p,
                'value': selection.percentage
            }
            if(selection.v_or_p === 'P') {
                var show = true;
            } else {
                var show = false;
            }
            _.each(plans, function(plan) {
                if(plan.item !== 'T&M') {
                    var trade_totals = $filter('filter')(plan.trade_totals, {'trade': trade}, true);
                    var current_total = $filter('filter')(trade_totals, {'revision': trade_totals.length}, true);
                    var contract_total = 0;
                    if(current_total.length != 1) {
                        toaster.pop('error', 'Cound not find trade totals for revision ' +
                            trade_totals.length + ' using revision ' + trade_totals[0].revision);
                        contract_total = trade_totals[0].total;
                    } else {
                        contract_total = current_total[0].total
                    }
                    draw_data.push({
                        show_number: row_data.show_number,
                        number: row_data.number,
                        name: row_data.name,
                        task_code: row_data.task_code,
                        revision: revision,
                        v_or_p: row_data.v_or_p,
                        value: row_data.value,
                        plan: plan.item,
                        show_input: show,
                        contract: contract_total,
                        draw: 0,
                    });

                    if(row_data) {
                        row_data.show_number = false;
                        row_data.name = null;
                        row_data.revision = null;
                        row_data.v_or_p = null;
                        row_data.value = null;
                    }
                }
            });

            return draw_data;
        }

        function getEmails() {
            var deferred = $q.defer();
            BillingSettings.query({
                'trade_code': current_trade_code, 
                'company_code': current_company_code }, function(billing_settings) {
                deferred.resolve(billing_settings[0].company_emails);
            });

            return deferred.promise;
        }

        return {
            loadSettings: loadSettings,
            getSettings: getSettings,
            getBuilder: getBuilder,
            getProjectDraws: getProjectDraws,
            getProjectOptions: getProjectOptions,
            getProjectSettings: getProjectSettings,
            add: add,
            getEmails: getEmails
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/services/trade-draw-service.js